<app-exam *ngIf="checkoutType === checkoutTypes.Exam"></app-exam>
<!--<app-products *ngIf="checkoutType === checkoutTypes.Products"></app-products>
<app-renewal *ngIf="checkoutType === checkoutTypes.Renewal"></app-renewal>-->

<app-products-renewal *ngIf="checkoutType === checkoutTypes.ProductsRenewal"></app-products-renewal>

<div *ngIf="isCartEmpty">
	<h1>Your cart is empty.</h1>
</div>